var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamera1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 6.314c0-.292 0-.438.012-.56a2.5 2.5 0 0 1 2.242-2.242c.122-.012.276-.012.584-.012.119 0 .178 0 .228-.003a1.667 1.667 0 0 0 1.446-1.042c.019-.047.036-.1.071-.205a3.85 3.85 0 0 1 .072-.205A1.667 1.667 0 0 1 7.1 1.003C7.15 1 7.206 1 7.318 1h4.031c.111 0 .167 0 .217.003a1.667 1.667 0 0 1 1.446 1.042c.019.047.036.1.071.205.035.105.053.158.072.205.24.597.803 1.003 1.446 1.042.05.003.11.003.228.003.307 0 .461 0 .584.012a2.5 2.5 0 0 1 2.241 2.242c.013.122.013.268.013.56v6.52c0 1.4 0 2.1-.273 2.634a2.5 2.5 0 0 1-1.092 1.093c-.535.272-1.235.272-2.635.272H5c-1.4 0-2.1 0-2.635-.272a2.5 2.5 0 0 1-1.093-1.093C1 14.934 1 14.233 1 12.833V6.314Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.333 13.083a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgCamera1;